import { LazyImage } from '@ui/common/lazy-image.tsx';
import { Button, ButtonGroup, Skeleton } from '@heroui/react';
import { Add, Heart, Minus, Trash } from 'iconsax-react';

export type CartDesktopProductProps = {
  image?: string;
  title?: string;
  description?: string;
  price?: string;
  itemPrice?: string;
  count?: string;
  value?: string;
  isFavorite?: boolean;
  onTrashPress?: () => void;
  onFavoritePress?: () => void;
  onMinusPress?: () => void;
  onPlusPress?: () => void;
  isLoading?: boolean;
  isEditable?: boolean;
};

export const CartDesktopProduct = ({
  image,
  title = 'Название',
  description = 'Описание',
  price = '1 000 тг',
  itemPrice = '1',
  count,
  value = '1',
  isFavorite,
  onFavoritePress,
  onPlusPress,
  onMinusPress,
  onTrashPress,
  isLoading = false,
  isEditable = false,
}: CartDesktopProductProps) => {
  return (
    <div className="flex flex-row">
      <div className="w-[140px] h-[140px] rounded-2xl overflow-hidden">
        <LazyImage src={image} />
      </div>

      <div className="flex flex-col mt-3 gap-y-3 flex-grow pl-6">
        <Skeleton isLoaded={!isLoading}>
          <p className="text-[#222222] text-ellipsis line-clamp-1">{title}</p>
        </Skeleton>

        <Skeleton isLoaded={!isLoading} className="mt-1.5">
          <p className="text-[#9CA5AC] text-sm text-ellipsis line-clamp-1">
            {description}
          </p>
        </Skeleton>
      </div>

      {count && <p className="text-[#60656C]">{count}</p>}

      {isEditable && (
        <div className="flex flex-col">
          <div className="flex flex-row items-center justify-between">
            <ButtonGroup>
              <Button
                disabled={isLoading}
                size="sm"
                className="bg-[#F5F5F5]"
                disableAnimation
                isIconOnly
                radius="full"
                onPress={onMinusPress}
              >
                <Minus
                  className="select-none border-none outline-none"
                  color="#222222"
                  size="16"
                  variant="Outline"
                />
              </Button>
              <Button
                size="sm"
                className="bg-[#F5F5F5] text-[#222222]"
                disableAnimation
                isIconOnly
                radius="full"
              >
                {value}
              </Button>
              <Button
                size="sm"
                disabled={isLoading}
                className="bg-[#F5F5F5]"
                disableAnimation
                isIconOnly
                radius="full"
                onPress={onPlusPress}
              >
                <Add
                  className="select-none border-none outline-none"
                  color="#222222"
                  size="16"
                  variant="Outline"
                />
              </Button>
            </ButtonGroup>
          </div>
          <p className="text-[#9CA5AC] text-xs text-center mt-2">
            {itemPrice} ₸/шт
          </p>
        </div>
      )}

      <div className="flex flex-col items-end justify-between pl-16">
        <Skeleton isLoaded={!isLoading}>
          <p className="text-[#222222] text-base font-semibold text-ellipsis line-clamp-1">
            {price}
          </p>
        </Skeleton>

        {isEditable && (
          <div className="flex flex-row items-center gap-x-6">
            <Button
              size="sm"
              isIconOnly
              radius="full"
              variant="light"
              disabled={isLoading}
              onPress={onFavoritePress}
            >
              {!isFavorite && (
                <Heart
                  className="select-none border-none outline-none"
                  color="#222222"
                  size="24"
                  variant="Outline"
                />
              )}
              {isFavorite && (
                <Heart
                  className="select-none border-none outline-none"
                  color="#F53639"
                  size="26"
                  variant="Bold"
                />
              )}
            </Button>

            <Button
              size="sm"
              isIconOnly
              radius="full"
              variant="light"
              onPress={onTrashPress}
              disabled={isLoading}
            >
              <Trash
                className="select-none border-none outline-none"
                color="#222222"
                size="24"
                variant="Outline"
              />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
